export const ka = {
  title: 'VIIRS აქტიური ხანძარი',
  subtitle: '(ყოველდღიური, 375 მ, გლობალური, NASA)',
  download_data: 'https://earthdata.nasa.gov/earth-observation-data/near-real-time/firms/active-fire-data',
  learn_more: 'https://earthdata.nasa.gov/earth-observation-data/near-real-time/firms/viirs-i-band-active-fire-data',
  content: [
    {
      label: 'ფუნქცია',
      value: 'აჩვენებს ხანძრის გაფრთხილების მონაცემებს ბოლო 24 საათის, 48 საათის, 72 საათის ან 7 დღის განმავლობაში',
    },
    {
      label: 'რეზოლუცია',
      value: '375 × 375 მეტრი',
    },
    {
      label: 'გეოგრაფიული გაშუქება',
      value: 'გლობალური',
    },
    {
      label: 'წყარო',
      value: 'NASA',
    },
    {
      label: 'სიხშირე',
      value: 'დღეში ორჯერ',
    },
    {
      label: 'შინაარსის თარიღი',
      value: 'თითქმის რეალურ დროში',
    },
    {
      label: 'გაფრთხილება',
      value:
        'ყველა ხანძარი არ არის გამოვლენილი. არსებობს რამდენიმე მიზეზი, რის გამოც VIIRS-მა შესაძლოა ვერ აღმოაჩინა გარკვეული ხანძარი. ხანძარი შესაძლოა სატელიტური ესტაკადებს შორის გაჩნდა და დასრულდა. ხანძარი შეიძლება იყოს ძალიან მცირე ან ზედმეტად გრილი, რომ 375 მეტრიან პიქსელში აღმოჩენილიყო. ღრუბლიანმა საფარმა, ძლიერმა კვამლმა ან ხის ტილომ შეიძლება მთლიანად დაფაროს ცეცხლი.',
    },
    {
      label: 'ლიცენზია',
      value:
        'ჩვენ ვაღიარებთ მონაცემების და გამოსახულების გამოყენებას LANCE FIRMS-დან, რომელსაც მართავს NASA/GSFC/დედამიწის მეცნიერების მონაცემთა და საინფორმაციო სისტემა (ESDIS) NASA/HQ-ის დაფინანსებით. \n\nნასას მონაცემთა და ინფორმაციის პოლიტიკა',
    },
  ],
  overview: {
    label: 'მიმოხილვა',
    value:
      'VIIRS აქტიური ხანძრის მონაცემები (VNP14IMGT) არის ხანძრის მონიტორინგის უახლესი პროდუქტი FIRMS-ისთვის (ცეცხლის ინფორმაცია რესურსების მართვის სისტემისთვის), რომელიც განსაზღვრავს გლობალური ხანძრის ადგილებს თითქმის რეალურ დროში. ინფორმაცია გროვდება Visible Infrared Imaging Radiometer Suite (VIIRS) სენსორიდან და მუშავდება ხანძრის აღმოჩენის ალგორითმით აქტიური ხანძრის დასანიშნად. რუკაზე თითოეული წერტილი წარმოადგენს 375 მეტრიანი პიქსელის ცენტრს, რომელიც მონიშნულია ალგორითმის მიერ.',
  },
  citation: {
    label: 'ციტატა',
    value:
      'NASA FIRMS. "VIIRS აქტიური ხანძარი." ხელმისაწვდომია Global Forest Watch-ის მეშვეობით 29/01/2025. www.globalforestwatch.org',
  },
};
